<template>
  <layout-navbar
    :menu-items="menuItems"
    :is-loading="false"
    :config="config"
    :company="company"
    :user="user"
    @toggle="toggleProfile()"
    @search="toggleSearch()"
    @logout="logout()"
    @toggleNotifications="toggleNotifications(), handleAnalytics()"
  >
    <search-container
      class="search"
      :is-opened="isSearchOpen"
      @search="toggleSearch()"
      @close="isSearchOpen = false"
    />
  </layout-navbar>
</template>

<script>
import LayoutNavbar from '@components/Layout/LayoutNavbar'
import * as types from '@store/types'
import { mapActions, mapGetters } from 'vuex'
import SearchContainer from '@containers/Search/SearchContainer'

export default {
  components: { LayoutNavbar, SearchContainer },

  data () {
    return {
      isSearchOpen: false
    }
  },

  computed: {
    ...mapGetters({
      user: types.USER,
      config: types.CONFIG_MAIN,
      company: types.COMPANY,
      credentials: types.AUTH_CREDENTIALS,
      auth: types.AUTH
    }),

    menuItems () {
      return [
        {
          name: 'Minhas informações',
          icon: 'user-profile',
          path: { name: 'Meu perfil' }
        },
        {
          name: 'Meus resgates',
          icon: 'receipt',
          path: { name: 'Resgates' }
        },
        {
          name: 'Meus favoritos',
          icon: 'bookmark',
          path: '/campanhas?favorites=true'
        },
        ...(
          this.$can('vidalink')
            ? [{
              name: 'Cartão farmácia',
              icon: 'windows-heart',
              path: '/cartao-farmacia'
            }]
            : []
        ),
        {
          name: 'Suporte',
          icon: 'question-circle',
          path: (this.config && this.config.support_link) || 'https://kaledo.zendesk.com/hc/pt-br',
          external: true
        }
      ]
    }
  },

  methods: {
    ...mapActions({
      toggleProfile: types.LAYOUT_PROFILE,
      toggleNotifications: types.LAYOUT_NOTIFICATIONS
    }),

    toggleSearch () {
      this.isSearchOpen = !this.isSearchOpen
    },

    logout () {
      this.$store.dispatch(types.AUTH_LOGOUT)
    },
    handleAnalytics () {
      window.dataLayer.push({
        event: 'area-de-notificacoes',
        company_name: this.config.title
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Layout/LayoutNavbar.vue